import React, { Component } from 'react';
import Header from 'component/Header';
import { withRouter } from 'react-router-dom';
import { Modal } from 'm-ui';
import { renderRoutes } from 'react-router-config';
import { connect } from 'react-redux';
import { appRoutes } from '../router';
import { RouteComponentProps } from 'react-router';
import * as Sentry from '@sentry/browser';
import {
    getUserInfoThunk,
    getPopulationTypesThunk,
    getCollectedTagThunk,
    getUserModelSpeedAuthThunk,
    getUserPrivateModelAuthThunk,
} from 'redux/common/actions';
import { getAnalyseIndexThunk, getMaxDate } from 'redux/report/actions';
import { ThunkDispatch } from 'redux-thunk';
import { UserInfo, UserModelSpeedAuthAndType } from 'redux/common/type';
import Store from 'redux/type';
import { checkAccountInfo, clearAccountId, refreshPassToken, setUrlAccountId } from 'utils/login';
import { RouterPath } from 'constants/constants';
import { MessageCenterProvider } from '@ad/message-center';
import { getMsgConf } from '../utils/msghelper';
import { isEmbedIntoPlatform } from '../utils/embed';
import { getUserSpeedAuthAndType } from 'service/population';

interface User {
    userId: number;
    userName: string;
    headUrl: string;
}

type AppProps = RouteComponentProps & {
    adUser: UserInfo;
    adAuth: UserModelSpeedAuthAndType;
    initialize(params: string): void;
    getUserAnalyse(): void;
    getMaxDate(): void;
    getPopulationTypes(): void;
    getCollectedTags(): void;
    getUserAuth(id): void;
    getUserPrivateModelAuth(): void;
};

class App extends Component<AppProps> {
    initializing: boolean;

    state = {
        redirectUrl: '',
        adAuth: {},
    };

    componentDidCatch(error, errorInfo) {
        Sentry.withScope((scope) => {
            Object.keys(errorInfo).forEach((key) => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    }

    async componentDidMount() {
        try {
            this.initializing = true;
            await this.checkUserInfo();
            this.props.getUserAnalyse();
            this.props.getCollectedTags();
            this.props.getUserAuth(this.props.adUser.user.userId);
            this.props.getUserPrivateModelAuth();
        } catch (e) {
            // tslint:disable-next-line no-console
            console.log('sso init failed', e);
        } finally {
            this.initializing = false;
        }
    }

    componentDidUpdate(prevProps) {
        const __ACCOUNT_ID__ = '__accountId__';
        const searchParser = new URLSearchParams(window.location.search);
        // 用户已经成功登入系统
        if (localStorage.getItem(__ACCOUNT_ID__) && !searchParser.get(__ACCOUNT_ID__)) {
            const { accountId } = JSON.parse(localStorage.getItem(__ACCOUNT_ID__));
            setUrlAccountId(accountId);
        } else if (
            !this.initializing &&
            //     /**
            //      * 因为初次访问的 pathname 为空，重定向到 /manage 会触发 componentDidUpdate，
            //      * 而此时 initSSO 还没完成，token还是旧的，导致checkUserInfo失败，
            //      * 所以加一个 initializing 的控制
            //      */
            prevProps.location.pathname !== this.props.location.pathname
        ) {
            this.checkUserInfo();
        }
        // 加载了不同的router 重新检查 user 是否登陆
        // if (
        //     !this.initializing &&
        //     /**
        //      * 因为初次访问的 pathname 为空，重定向到 /manage 会触发 componentDidUpdate，
        //      * 而此时 initSSO 还没完成，token还是旧的，导致checkUserInfo失败，
        //      * 所以加一个 initializing 的控制
        //      */
        //     prevProps.location.pathname !== this.props.location.pathname
        // ) {
        //     const __ACCOUNT_ID__ = '__accountId__';
        //     const searchParser = new URLSearchParams(window.location.search);
        //     // 用户已经成功登入系统
        //     if (localStorage.getItem(__ACCOUNT_ID__) && !searchParser.get(__ACCOUNT_ID__)) {
        //         const {accountId} = JSON.parse(localStorage.getItem(__ACCOUNT_ID__));
        //         setUrlAccountId(accountId);
        //     } else {
        //         this.checkUserInfo();
        //     }
        // }
    }

    render() {
        const { adUser } = this.props;
        const user = adUser.user;
        const msgConf = getMsgConf();
        let realRenderRoutes = appRoutes.slice();
        // 嵌入到其它平台之后，隐藏 header
        const ifShowHeader = !isEmbedIntoPlatform();
        // 投放报表白名单控制
        return user?.userId ? (
            <div>
                <MessageCenterProvider domain={window.location.origin}>
                    {ifShowHeader ? (
                        <Header
                            userInfo={{
                                ...user,
                                accountUcId: adUser.accountUcId,
                                kaAccountUcId: adUser.kaAccountUcId,
                                adminUserId: adUser.adminUserId,
                                agentUserId: adUser.agentUserId,
                                accountUserId: adUser.accountUserId,
                                isKa: adUser.isKa,
                                agentAccount: adUser.agentAccount,
                                appId: adUser.appId,
                            }}
                        />
                    ) : null}

                    <div className="app" style={{ paddingTop: ifShowHeader ? 64 : 0 }}>
                        <div className="app__content">
                            {/* 人群画像/人群对比时候Tab的吸顶效果靠这个实现。*/}
                            <div className="slot"></div>
                            {renderRoutes(realRenderRoutes)}
                        </div>
                    </div>
                </MessageCenterProvider>
            </div>
        ) : null;
    }

    async checkUserInfo() {
        try {
            sessionStorage.setItem('feedback_search', window.location.search);

            await this.props.initialize(this.state.redirectUrl);
            const userId = String(this.props.adUser.user.userId);
            const data = await getUserSpeedAuthAndType(userId);
            Sentry.configureScope((scope) => {
                scope.setUser({ id: userId });
            });
            this.setState({
                redirectUrl: '',
                adAuth: data,
            });
            checkAccountInfo(this.props.adUser.isKa);
            localStorage.setItem('dsp_user', userId);
            // 防止代理商出现权限错误
            window.onfocus = () => {
                const newUser = localStorage.getItem('dsp_user');
                if (newUser !== userId) {
                    window.location.href = RouterPath.FRONT_PAGE;
                }
            };
        } catch (e) {
            const urlSearchParams = new URLSearchParams(this.props.location.search);
            let redirectUrl = urlSearchParams.get('redirectUrl') || window.location.href;
            if (!/kuaishou/.test(redirectUrl)) {
                redirectUrl = '';
            }
            // 如果没有登陆并且不是白名单路由就推向欢迎页
            if (e?.result === 109) {
                try {
                    this.setState({
                        redirectUrl,
                    });
                    const result = await refreshPassToken();
                    if (result === 1) {
                        await this.checkUserInfo();
                    } else {
                        clearAccountId();
                        window.location.href = '/?showLogin=true';
                    }
                } catch (e) {
                    clearAccountId();
                    window.location.href = '/?showLogin=true';
                }
            } else if (e.result === 52) {
                Modal.error({
                    title: '请先开通权限',
                    content: '错误原因： ' + e.error_msg,
                });
                window.location.href = '//e.kuaishou.com';
            }
        }
        await this.props.getPopulationTypes();
    }
}

export default withRouter(
    connect(
        (state: Store) => ({
            adUser: state.common.userInfo,
            adAuth: state.common.authorizeAndType,
        }),
        (dispatch: ThunkDispatch<Promise<void>, null, any>) => ({
            initialize: (redirectUrl) => dispatch(getUserInfoThunk(redirectUrl)),
            getUserAnalyse: () => dispatch(getAnalyseIndexThunk()),
            getPopulationTypes: () => dispatch(getPopulationTypesThunk()),
            getCollectedTags: () => {
                dispatch(getCollectedTagThunk());
            },
            getUserAuth: (id) => {
                dispatch(getUserModelSpeedAuthThunk(id));
            },
            getUserPrivateModelAuth: () => {
                dispatch(getUserPrivateModelAuthThunk());
            },
        }),
    )(App),
);
